<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import { PopupButton } from '@tma.js/sdk-vue';
import { setHaptic } from '@/tools/setTelegramHaptick';
import { useStore } from 'vuex';
import router from "@/router";
import Order from "@/models/order";
import { getAllPoints } from '@/composables/itemWorker'
import { getOrdersByPoint } from '@/composables/orderWorkerk'
import SelectPoint from '@/components/mobile/telegram//selected_point_components/SelectPoint.vue';
import OrdersListItem from '@/components/mobile/telegram/order_components/OrdersListItem.vue';
import AnimatePlaceHolder from '@/components/mobile/telegram/AnimatePlaceHolder.vue';
import { createPopupManager } from '@/tools/setTelegramPopUp'

type Point = {
  id: number,
  name: string,
  counteragent_id: string,
  uuid: string
}

const defaultOrder: Order = {
  point: 1,
  id: 1,
  status: 'Новый',
  date_create: '',
  products: [
    {
      quantity: 1,
      product: {
        id: 1,
        quantity: 1,
        description: "",
        icon: "",
        name: "",
        packaging: {
          count: 1,
          id: '',
          name: ''
        },
      }
    },
  ],
  comment: 'Comment',
};


const store = useStore();
const orders = ref<Order[]>([defaultOrder, defaultOrder, defaultOrder]); 
const points = ref<Point[]>([]);
const selectedPoint = ref<Point | null>(null);
const showAllOrders = ref<boolean>(false);
const ordersIsResieved = ref<boolean>(false);
const popupManager = createPopupManager();

onMounted(async() => {
  await getPoints();
})

async function getPoints() {
  points.value = await getAllPoints();
  localStorage.setItem("points", JSON.stringify(points.value));
  store.dispatch("setAllPoints", points.value)
  selectedPoint.value = store.getters.getSelectedPoint;
  console.log('selectedPoint.value=', selectedPoint.value)
  console.log('store.getters.getSelectedPoint=', store.getters.getSelectedPoint)
  if (selectedPoint.value !== null) {
    await getOrderAllOrdersByPoint(selectedPoint.value.id);
  }
}

const statusPriority: Record<string, number> = {
  'Новый': 1,
  'В сборке': 2,
  'Собран': 3,
  'В пути': 4,
  'Доставлен': 5
};

const sortedOrders = computed(() => {
  return [...orders.value].sort((a, b) => {
    const priorityA = statusPriority[a.status] ?? 999;
    const priorityB = statusPriority[b.status] ?? 999;
    
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return b.id - a.id;
  });
});

const filteredOrders = computed(() => {
  if (showAllOrders.value) {
    return sortedOrders.value;
  }
  return sortedOrders.value.filter(order => order.status !== 'Доставлен');
});

const existOrderStatusDelivered = computed(() => {
  return orders.value.some(order => order.status === 'Доставлен')
})

async function getOrderAllOrdersByPoint(point_id: number) {
  ordersIsResieved.value = false;
  orders.value = await getOrdersByPoint(point_id); 
  ordersIsResieved.value = true;
}

async function selectPoint(point: Point) {
  selectedPoint.value = point;
  localStorage.setItem('selectedPoint', JSON.stringify(point));
  store.dispatch('setSelectedPoint', point);
  const now = new Date().toISOString();
  localStorage.setItem('last_open_shop', now)
  store.dispatch('setLastOpenshop', now);
  setTimeout(() => {
    choosePoint();
  },100)
  await getOrderAllOrdersByPoint(point.id);
}

const isMoreThan15MinutesAgo = (dateString: string): boolean => {
  const targetDate = new Date(dateString);
  const currentDate = new Date();
  const diffInMilliseconds = currentDate.getTime() - targetDate.getTime();
  const minutes15InMilliseconds = 15 * 60 * 1000;

  return diffInMilliseconds > minutes15InMilliseconds;
};

function goToItems() {
  const lastOpenShop = store.getters.getLastOpenShop;
  if (lastOpenShop === null) {
    const now = new Date().toISOString();
    localStorage.setItem('last_open_shop', now)
    store.dispatch('setLastOpenshop', now);
  }
  if (isMoreThan15MinutesAgo(lastOpenShop)) {
    let buttons: PopupButton[];
    buttons = [
      {
        id: 'yes',
        text: 'Да',
        type: 'default'
      },
      {
        id: 'no',
        text: 'Нет',
        type: 'default'
      }
    ];
    popupManager.openPopup(`Вы находитесь на точке ${selectedPoint.value?.name}`,
      (buttonId) => {
        if (buttonId === 'yes') {
          popupManager.cleanup();
          const now = new Date().toISOString();
          localStorage.setItem('last_open_shop', now)
          store.dispatch('setLastOpenshop', now);
          router.push(`/shop?point_uuid=${selectedPoint.value?.uuid}&point_id=${selectedPoint.value?.id}`);
        }
        if (buttonId === 'no') {
          popupManager.cleanup();
          choosePoint();
        } 
      }, buttons
    )
  } else {
    router.push(`/shop?point_uuid=${selectedPoint.value?.uuid}&point_id=${selectedPoint.value?.id}`);
  }
}

function btnClick(btn_id: string, param?: Point) {
  setHaptic();
  switch(btn_id) {
    case 'selectPoint':
      if (param) selectPoint(param);
      break;
    case 'goToItems': 
      goToItems();
      break;
    case 'goToSettings':
      router.push('/settings');
      break;
    case 'goToReceipts':
      router.push('/receiving');
      break;
    case 'goToWorkpieces': 
      router.push('/work_pieces')
      break;
    default: 
      break;
  }
}

const openModalSelectPoint = ref<Boolean>(false)

function choosePoint() {
  openModalSelectPoint.value = !openModalSelectPoint.value
}

</script>

<template>
  <Transition name="fade">
    <div class="background-blur-choose-point" v-if="openModalSelectPoint" @click="choosePoint()"></div>
  </Transition>
  <Transition name="slideUp">
    <SelectPoint v-if="openModalSelectPoint"
      :points="points"
      :selectedPoint="selectedPoint"
      @selectPoint="selectPoint"
      @closeModal="choosePoint()"
    />
  </Transition>
  <div class="home-wrapper">


    <Transition name="fade">
      <div class="choose-point" v-if="store.getters.USER.role !== 'zagotovshik'">
        <p class="selected-point__label">Выбранная точка</p>
        <p class="selected-point__name">{{ selectedPoint !== null ? selectedPoint.name : '---' }}</p>
        <AnimatePlaceHolder v-if="points.length === 0"
          width="100%"
          height="61px"
          border-radius="var(--border-radius-2)"
          style="margin-top: 10px;"
        />
        <button v-else
          type="button"
          class="point-btn btn"
          @click="choosePoint()"
        >
        {{ selectedPoint !== null ? 'Изменить точку' : 'Выбрать точку' }}
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.67578 12.1982C1.67578 12.1982 7.1886 7.05294 7.1886 6.68542C7.1886 6.3179 1.67578 1.1726 1.67578 1.1726" stroke="black" stroke-width="2.20513" stroke-linecap="round"/>
        </svg>
        </button>
      </div>
    </Transition>

    <Transition name="fade">
      <button v-if="selectedPoint !== null && (store.getters.USER.role === 'admin' || store.getters.USER.role === 'cass')"
        type="button"
        class="all-items-btn" 
        @click="btnClick('goToItems')"
      >
        Выбрать товары
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.67578 12.1982C1.67578 12.1982 7.1886 7.05294 7.1886 6.68542C7.1886 6.3179 1.67578 1.1726 1.67578 1.1726" stroke="black" stroke-width="2.20513" stroke-linecap="round"/>
        </svg>
      </button>
    </Transition>

    <Transition name="fade">
      <div class="label-orders-wrapper" v-if="selectedPoint && orders.length === 0 && ordersIsResieved === true">
        <div class="label-orders">
          <p>На этой точке пока нет заказов</p>
        </div>
      </div>
    </Transition>

    <Transition name="fade">
      <div class="orders-by-point" v-if="selectedPoint && orders.length > 0">
        <OrdersListItem
          v-for="(order, index) in filteredOrders"
          :key="order.id"
          :order="order"
          :isFirst="index === 0"
          :isLast="index === orders.length - 1"
          :isHistory="false"
          :point="selectedPoint"
          :isAdmin="false"
          :ordersIsResieved="ordersIsResieved"
        />
      </div>
    </Transition>

    <!-- УБирать кнопку если доставленных нет -->
    <Transition name="fade">
      <button v-if="selectedPoint && orders.length > 0 && ordersIsResieved === true && existOrderStatusDelivered"
        type="button"
        class="all-items-btn" 
        :style="{justifyContent: 'center', marginBottom: '100px'}"
        @click="showAllOrders = !showAllOrders"
      >
        {{ showAllOrders ?  'Скрыть доставленные' : 'Показать доставленные' }}
      </button>
    </Transition>

  </div>
</template>


<style scoped>

.orders-on-point {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: white;
  border-radius: var(--border-radius);
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
}

.background-blur-choose-point {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  background-color: #8E8E9290;
  backdrop-filter: blur(10px);
}

.selected-point__label {
  font-size: 16px;
  color: #989793;
}

.selected-point__name {
  font-size: 20px;
  font-weight: 500;
  margin-top: 5px;
}

.btn-choose-point {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  border-radius: var(--border-radius);
  padding: 17px 0 17px 0;
  gap: 15px;
}

.label-orders-wrapper{ 
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius);
}

.settings-item{
  display: flex;
}

.head-bnt-first-line {
  font-size: 18px;
  font-weight: 600;
  color: black;
  width: 100%;
  text-align: start;
}

.label-orders{
  font-size: 18px;
  color: black;
}

.header-orders{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.orders-by-point{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  gap: 10px;
}

.all-items-btn{
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  background-color: white;
  color: black;
  padding: 20px;
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--border-radius);
  font-size: 18px;
  font-weight: 500;
  transition: all .3s ease;
  box-shadow: var(--drop-shadow-item);
}

.point-btn:active {
  transform: var(--transform-scale-active);
}

.all-items-btn:active {
  transform: var(--transform-scale-active);
}


.btn {
  transition: all .3s ease;
}

.point-btn {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  -webkit-tap-highlight-color: transparent;
  font-size: 18px;
  width: 100%;
  background-color: #FFF1CC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: start;
  box-sizing: border-box;
  padding: 20px;
  border-radius: var(--border-radius-2);
  margin-top: 10px;
  color: black;
  box-shadow: var(--drop-shadow-item);
}

.choose-point {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  padding: 20px;
  background-color: white;
  border-radius: var(--border-radius);
  box-sizing: border-box;
  box-shadow: var(--drop-shadow-item);
  margin-top: 5px;
}

.home-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 430px;
  position: relative;
  margin-bottom: 100px;
}

</style>
